import { initAll } from "govuk-frontend";
import "./controllers"

initAll();
